import { defineComponent, ref, watch, computed, openBlock, createElementBlock, normalizeClass, createBlock, unref, createElementVNode, toDisplayString, createCommentVNode, useModel, withCtx, createVNode, mergeModels, useTemplateRef, shallowRef, createTextVNode, Fragment, withModifiers, renderList } from "vue";
import { mdiFolder, mdiFile, mdiArrowRight } from "@mdi/js";
import { basename } from "@nextcloud/paths";
import NcButton from "@nextcloud/vue/components/NcButton";
import NcCheckboxRadioSwitch from "@nextcloud/vue/components/NcCheckboxRadioSwitch";
import NcDialog from "@nextcloud/vue/components/NcDialog";
import NcIconSvgWrapper from "@nextcloud/vue/components/NcIconSvgWrapper";
import { formatFileSize, FileType } from "@nextcloud/files";
import NcDateTime from "@nextcloud/vue/components/NcDateTime";
import { t, _ as _export_sfc, n, l as logger, s as showError } from "./index.mjs";
import { g as getPreviewURL } from "./preview.mjs";
const _hoisted_1$1 = ["src"];
const _hoisted_2$1 = { key: 1 };
const _hoisted_3 = { class: "hidden-visually" };
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "ConflictPickerCard",
  props: {
    preview: {},
    mtime: {},
    size: {},
    isFolder: { type: Boolean },
    label: {},
    boldDate: { type: Boolean },
    boldSize: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const previewFailed = ref(false);
    watch(() => props.preview, () => {
      previewFailed.value = false;
    });
    const showPreview = computed(() => !!props.preview && !previewFailed.value);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(_ctx.$style.card)
      }, [
        !showPreview.value ? (openBlock(), createBlock(unref(NcIconSvgWrapper), {
          key: 0,
          class: normalizeClass([_ctx.$style.cardIcon, { [_ctx.$style.cardIcon_folder]: __props.isFolder }]),
          path: __props.isFolder ? unref(mdiFolder) : unref(mdiFile),
          size: 48
        }, null, 8, ["class", "path"])) : (openBlock(), createElementBlock("img", {
          key: 1,
          class: normalizeClass(_ctx.$style.cardPreview),
          src: __props.preview,
          alt: "",
          loading: "lazy",
          onError: _cache[0] || (_cache[0] = ($event) => previewFailed.value = true)
        }, null, 42, _hoisted_1$1)),
        createElementVNode("span", {
          class: normalizeClass(_ctx.$style.cardDescription)
        }, [
          __props.mtime ? (openBlock(), createBlock(unref(NcDateTime), {
            key: 0,
            class: normalizeClass({ [_ctx.$style.bold]: __props.boldDate }),
            timestamp: __props.mtime,
            relativeTime: false,
            format: { timeStyle: "short", dateStyle: "medium" }
          }, null, 8, ["class", "timestamp"])) : (openBlock(), createElementBlock("span", _hoisted_2$1, toDisplayString(unref(t)("Last modified date unknown")), 1)),
          __props.size !== void 0 ? (openBlock(), createElementBlock("span", {
            key: 2,
            class: normalizeClass({ [_ctx.$style.bold]: __props.boldSize })
          }, toDisplayString(unref(formatFileSize)(__props.size)), 3)) : createCommentVNode("", true)
        ], 2),
        createElementVNode("span", _hoisted_3, toDisplayString(__props.label), 1)
      ], 2);
    };
  }
});
const card = "_card_ysn65_1";
const cardIcon = "_cardIcon_ysn65_7";
const cardPreview = "_cardPreview_ysn65_8";
const cardIcon_folder = "_cardIcon_folder_ysn65_20";
const cardDescription = "_cardDescription_ysn65_30";
const bold = "_bold_ysn65_40";
const style0$2 = {
  card,
  cardIcon,
  cardPreview,
  cardIcon_folder,
  cardDescription,
  bold
};
const cssModules$2 = {
  "$style": style0$2
};
const ConflictPickerCard = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__cssModules", cssModules$2]]);
const PREVIEW_SIZE = 64;
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "ConflictPickerEntry",
  props: /* @__PURE__ */ mergeModels({
    existing: {},
    incoming: {},
    isSingle: { type: Boolean }
  }, {
    "existingSelected": { type: Boolean, ...{ required: true } },
    "existingSelectedModifiers": {},
    "incomingSelected": { type: Boolean, ...{ required: true } },
    "incomingSelectedModifiers": {}
  }),
  emits: ["update:existingSelected", "update:incomingSelected"],
  setup(__props, { expose: __expose }) {
    const existingSelected = useModel(__props, "existingSelected");
    const incomingSelected = useModel(__props, "incomingSelected");
    const props = __props;
    __expose({ validate });
    const isFileSystemEntry = (o) => "FileSystemEntry" in window && o instanceof window.FileSystemEntry;
    const isFileSystemFileEntry = (o) => "FileSystemFileEntry" in window && o instanceof window.FileSystemFileEntry;
    const validationMessage = ref("");
    const incomingPreview = ref();
    const existingPreview = ref();
    const incomingMTime = ref();
    const existingMTime = ref();
    const incomingSize = ref();
    const existingSize = ref();
    const conflictResolved = computed(() => incomingSelected.value || existingSelected.value);
    const isExistingFolder = computed(() => props.existing.type === FileType.Folder);
    const isIncomingFolder = computed(() => {
      if (isFileSystemEntry(props.incoming)) {
        return props.incoming.isDirectory;
      } else if (props.incoming instanceof File) {
        return false;
      }
      return props.incoming.type === FileType.Folder;
    });
    const incomingNewer = computed(() => !!incomingMTime.value && !!existingMTime.value && incomingMTime.value > existingMTime.value);
    const existingNewer = computed(() => !!incomingMTime.value && !!existingMTime.value && existingMTime.value > incomingMTime.value);
    const incomingLarger = computed(() => incomingSize.value !== void 0 && existingSize.value !== void 0 && incomingSize.value > existingSize.value);
    const existingLarger = computed(() => incomingSize.value !== void 0 && existingSize.value !== void 0 && existingSize.value > incomingSize.value);
    watch(() => props.existing, async () => {
      existingMTime.value = getMTime(props.existing);
      existingSize.value = getSize(props.existing);
      existingPreview.value = await getPreview(props.existing);
    });
    watch(() => props.incoming, async () => {
      const file = await getFileOrNode(props.incoming);
      if (file === null) {
        return;
      }
      incomingMTime.value = getMTime(file);
      incomingSize.value = getSize(file);
      incomingPreview.value = await getPreview(file);
    });
    async function getFileOrNode(input) {
      if (isFileSystemFileEntry(input)) {
        return await new Promise((resolve, reject) => input.file(resolve, reject));
      } else if (isFileSystemEntry(input)) {
        return null;
      }
      return input;
    }
    function getSize(input) {
      return input.size;
    }
    function getMTime(input) {
      if (input instanceof File) {
        const mtime = input.lastModified;
        if (mtime > 0) {
          return new Date(mtime);
        }
      } else {
        return input.mtime;
      }
    }
    async function getPreview(input) {
      if (input instanceof File) {
        return await getFilePreview(input);
      }
      return getPreviewURL(input, { size: PREVIEW_SIZE })?.toString();
    }
    async function getFilePreview(file) {
      if (!file.type.startsWith("image/")) {
        return void 0;
      }
      const { resolve, promise } = Promise.withResolvers();
      const reader = new FileReader();
      reader.onload = async (e) => {
        const result = e?.target?.result;
        if (result instanceof ArrayBuffer) {
          const blob = new Blob([result], { type: file.type });
          const url = URL.createObjectURL(blob);
          resolve(url);
          return;
        }
        resolve(void 0);
      };
      reader.readAsArrayBuffer(file);
      return promise;
    }
    function validate() {
      validationMessage.value = !incomingSelected.value && !existingSelected.value ? t("You need to choose at least one conflict solution") : "";
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("fieldset", {
        class: normalizeClass(_ctx.$style.pickerEntry)
      }, [
        createElementVNode("legend", null, toDisplayString(__props.existing.displayname), 1),
        !__props.isSingle ? (openBlock(), createBlock(unref(NcCheckboxRadioSwitch), {
          key: 0,
          modelValue: existingSelected.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => existingSelected.value = $event),
          class: normalizeClass(_ctx.$style.pickerEntryColumn),
          error: !!validationMessage.value,
          helperText: validationMessage.value,
          required: !conflictResolved.value
        }, {
          default: withCtx(() => [
            createVNode(ConflictPickerCard, {
              preview: existingPreview.value,
              mtime: existingMTime.value,
              size: existingSize.value,
              isFolder: isExistingFolder.value,
              label: unref(t)("Existing version"),
              boldDate: existingNewer.value,
              boldSize: existingLarger.value
            }, null, 8, ["preview", "mtime", "size", "isFolder", "label", "boldDate", "boldSize"])
          ]),
          _: 1
        }, 8, ["modelValue", "class", "error", "helperText", "required"])) : (openBlock(), createBlock(ConflictPickerCard, {
          key: 1,
          class: normalizeClass(_ctx.$style.pickerEntryColumn),
          preview: existingPreview.value,
          mtime: existingMTime.value,
          size: existingSize.value,
          isFolder: isExistingFolder.value,
          label: unref(t)("Existing version"),
          boldDate: existingNewer.value,
          boldSize: existingLarger.value
        }, null, 8, ["class", "preview", "mtime", "size", "isFolder", "label", "boldDate", "boldSize"])),
        createVNode(unref(NcIconSvgWrapper), {
          class: normalizeClass(_ctx.$style.pickerEntryArrow),
          directional: "",
          path: unref(mdiArrowRight)
        }, null, 8, ["class", "path"]),
        !__props.isSingle ? (openBlock(), createBlock(unref(NcCheckboxRadioSwitch), {
          key: 2,
          modelValue: incomingSelected.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => incomingSelected.value = $event),
          class: normalizeClass(_ctx.$style.pickerEntryColumn),
          error: !!validationMessage.value,
          helperText: validationMessage.value,
          required: !conflictResolved.value
        }, {
          default: withCtx(() => [
            createVNode(ConflictPickerCard, {
              preview: incomingPreview.value,
              mtime: incomingMTime.value,
              size: incomingSize.value,
              isFolder: isIncomingFolder.value,
              label: unref(t)("New version"),
              boldDate: incomingNewer.value,
              boldSize: incomingLarger.value
            }, null, 8, ["preview", "mtime", "size", "isFolder", "label", "boldDate", "boldSize"])
          ]),
          _: 1
        }, 8, ["modelValue", "class", "error", "helperText", "required"])) : (openBlock(), createBlock(ConflictPickerCard, {
          key: 3,
          class: normalizeClass(_ctx.$style.pickerEntryColumn),
          preview: incomingPreview.value,
          mtime: incomingMTime.value,
          size: incomingSize.value,
          isFolder: isIncomingFolder.value,
          label: unref(t)("New version"),
          boldDate: incomingNewer.value,
          boldSize: incomingLarger.value
        }, null, 8, ["class", "preview", "mtime", "size", "isFolder", "label", "boldDate", "boldSize"]))
      ], 2);
    };
  }
});
const pickerEntry = "_pickerEntry_k9pc8_1";
const pickerEntryArrow = "_pickerEntryArrow_k9pc8_14";
const style0$1 = {
  pickerEntry,
  pickerEntryArrow
};
const cssModules$1 = {
  "$style": style0$1
};
const ConflictPickerEntry = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["__cssModules", cssModules$1]]);
const _hoisted_1 = { class: "hidden-visually" };
const _hoisted_2 = {
  key: 0,
  class: "hidden-visually"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ConflictPicker",
  props: {
    container: {},
    dirname: {},
    existing: {},
    incoming: {},
    recursiveUpload: { type: Boolean },
    isOverwriting: { type: Boolean }
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const blockedTitle = t("You need to select at least one version of each file to continue.");
    const formElement = useTemplateRef("form");
    const conflictEntries = useTemplateRef("conflictEntry");
    const isSingle = computed(() => props.incoming.length === 1);
    const newSelected = shallowRef([...props.incoming]);
    const oldSelected = shallowRef([]);
    const isNoNewSelected = computed(() => newSelected.value.length === 0);
    const areAllNewSelected = computed(() => newSelected.value.length === props.incoming.length);
    const areSomeNewSelected = computed(() => !areAllNewSelected.value && !isNoNewSelected.value);
    const areAllOldSelected = computed(() => oldSelected.value.length === props.existing.length);
    const areSomeOldSelected = computed(() => !areAllOldSelected.value && !isNoNewSelected.value);
    const areConflictsResolved = computed(() => {
      for (const conflict of props.incoming) {
        if (oldSelected.value.includes(conflict) || newSelected.value.includes(conflict)) {
          continue;
        }
        return false;
      }
      return true;
    });
    const dialogName = computed(() => isSingle.value ? t("Select file to keep") : t("Select files to keep"));
    const folderName = computed(() => basename(props.dirname ?? "") || t("All files"));
    const descriptionParts = computed(() => {
      const message = isSingle.value ? t("An item with the same name already exists in {dirname}.") : t("Items with the same name already exist in {dirname}, select which to keep.");
      const [before, after = ""] = message.split("{dirname}");
      return { before, after };
    });
    function onCancel() {
      emit("close", null);
    }
    function onReplace() {
      emit("close", {
        selected: [...props.incoming],
        renamed: [],
        skipped: []
      });
    }
    function onKeepBoth() {
      emit("close", {
        selected: [],
        renamed: [...props.incoming],
        skipped: []
      });
    }
    function onSkipAll() {
      logger.debug("Conflict skipped. Ignoring all conflicting files");
      emit("close", {
        selected: [],
        renamed: [],
        skipped: [...props.incoming]
      });
    }
    function onSelectAllNew(selected) {
      if (selected) {
        logger.debug("Selected all new files");
        newSelected.value = [...props.incoming];
      } else {
        logger.debug("Cleared new selection");
        newSelected.value = [];
      }
    }
    function onSelectAllOld(selected) {
      if (selected) {
        logger.debug("Selected all existing files");
        oldSelected.value = [...props.incoming];
      } else {
        logger.debug("Cleared old selection");
        oldSelected.value = [];
      }
    }
    function toggleOldSelected(conflict) {
      if (oldSelected.value.includes(conflict)) {
        oldSelected.value = oldSelected.value.filter((entry) => entry !== conflict);
      } else {
        oldSelected.value = [...oldSelected.value, conflict];
      }
    }
    function toggleNewSelected(conflict) {
      if (newSelected.value.includes(conflict)) {
        newSelected.value = newSelected.value.filter((entry) => entry !== conflict);
      } else {
        newSelected.value = [...newSelected.value, conflict];
      }
    }
    function onSubmit() {
      if (!areConflictsResolved.value) {
        for (const entry of conflictEntries.value) {
          entry.validate();
        }
        formElement.value.reportValidity();
        showError(blockedTitle);
        return;
      }
      const selected = newSelected.value.filter((entry) => !oldSelected.value.includes(entry));
      const renamed = newSelected.value.filter((entry) => oldSelected.value.includes(entry));
      const skipped = oldSelected.value.filter((entry) => !newSelected.value.includes(entry));
      emit("close", {
        renamed,
        selected,
        skipped
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NcDialog), {
        container: __props.container,
        class: normalizeClass(_ctx.$style.picker),
        name: dialogName.value,
        size: "large",
        onClosing: onCancel
      }, {
        actions: withCtx(() => [
          createVNode(unref(NcButton), {
            title: unref(t)("Cancel the entire operation"),
            "data-cy-conflict-picker-cancel": "",
            variant: "tertiary",
            onClick: onCancel
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(t)("Cancel")), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          createElementVNode("span", {
            class: normalizeClass(_ctx.$style.pickerActionSeparator)
          }, null, 2),
          isSingle.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createVNode(unref(NcButton), {
              variant: "secondary",
              onClick: onKeepBoth
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t)("Keep both")), 1)
              ]),
              _: 1
            }),
            createVNode(unref(NcButton), {
              variant: "primary",
              onClick: onReplace
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(t)("Replace")), 1)
              ]),
              _: 1
            })
          ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createVNode(unref(NcButton), { onClick: onSkipAll }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(unref(n)("Skip %n file", "Skip %n files", __props.incoming.length)), 1)
              ]),
              _: 1
            }),
            createVNode(unref(NcButton), {
              "aria-disabled": !areConflictsResolved.value,
              class: normalizeClass([
                _ctx.$style.pickerActionSubmit,
                {
                  [_ctx.$style.pickerActionSubmit_disabled]: !areConflictsResolved.value
                }
              ]),
              title: areConflictsResolved.value ? "" : unref(blockedTitle),
              type: "submit",
              variant: "primary",
              onClick: withModifiers(onSubmit, ["stop", "prevent"])
            }, {
              icon: withCtx(() => [
                createVNode(unref(NcIconSvgWrapper), {
                  directional: "",
                  path: unref(mdiArrowRight)
                }, null, 8, ["path"])
              ]),
              default: withCtx(() => [
                createTextVNode(" " + toDisplayString(unref(t)("Continue")) + " ", 1),
                !areConflictsResolved.value ? (openBlock(), createElementBlock("span", _hoisted_2, toDisplayString(unref(blockedTitle)), 1)) : createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["aria-disabled", "class", "title"])
          ], 64))
        ]),
        default: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(_ctx.$style.pickerHeader)
          }, [
            createElementVNode("p", {
              id: "conflict-picker-description",
              class: normalizeClass(_ctx.$style.pickerDescription)
            }, [
              createTextVNode(toDisplayString(descriptionParts.value.before), 1),
              createElementVNode("strong", null, toDisplayString(folderName.value), 1),
              createTextVNode(toDisplayString(descriptionParts.value.after), 1),
              _cache[1] || (_cache[1] = createElementVNode("br", null, null, -1)),
              !isSingle.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString(unref(t)("Existing files and folders will be deleted if not selected. If both are chosen, they will be renamed.")), 1),
                _cache[0] || (_cache[0] = createElementVNode("br", null, null, -1))
              ], 64)) : createCommentVNode("", true),
              __props.recursiveUpload ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                createTextVNode(toDisplayString(unref(t)("When a new folder is selected, the content is written into the existing folder and a recursive conflict resolution is performed.")), 1)
              ], 64)) : __props.isOverwriting ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                createTextVNode(toDisplayString(unref(t)("When a new folder is selected, any files within it will also be overwritten.")), 1)
              ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 3 }, [
                createTextVNode(toDisplayString(unref(t)("When a new folder is selected, any conflicting files within it will also be overwritten.")), 1)
              ], 64))
            ], 2)
          ], 2),
          createElementVNode("form", {
            ref: "form",
            "aria-labelledby": "conflict-picker-description",
            class: normalizeClass(_ctx.$style.pickerForm),
            onSubmit: withModifiers(onSubmit, ["prevent", "stop"])
          }, [
            !isSingle.value ? (openBlock(), createElementBlock("fieldset", {
              key: 0,
              class: normalizeClass(_ctx.$style.pickerSelectAll)
            }, [
              createElementVNode("legend", _hoisted_1, toDisplayString(unref(t)("Select all checkboxes")), 1),
              createVNode(unref(NcCheckboxRadioSwitch), {
                modelValue: areAllOldSelected.value,
                indeterminate: areSomeOldSelected.value,
                "onUpdate:modelValue": onSelectAllOld
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t)("Existing files")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "indeterminate"]),
              _cache[2] || (_cache[2] = createElementVNode("span", null, null, -1)),
              createVNode(unref(NcCheckboxRadioSwitch), {
                modelValue: areAllNewSelected.value,
                indeterminate: areSomeNewSelected.value,
                "onUpdate:modelValue": onSelectAllNew
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(unref(t)("New files")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "indeterminate"])
            ], 2)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.existing, (node, index) => {
              return openBlock(), createBlock(ConflictPickerEntry, {
                ref_for: true,
                ref: "conflictEntry",
                key: node.fileid,
                isSingle: isSingle.value,
                incoming: __props.incoming[index],
                existing: node,
                incomingSelected: newSelected.value.includes(__props.incoming[index]),
                existingSelected: oldSelected.value.includes(__props.incoming[index]),
                "onUpdate:existingSelected": ($event) => toggleOldSelected(__props.incoming[index]),
                "onUpdate:incomingSelected": ($event) => toggleNewSelected(__props.incoming[index])
              }, null, 8, ["isSingle", "incoming", "existing", "incomingSelected", "existingSelected", "onUpdate:existingSelected", "onUpdate:incomingSelected"]);
            }), 128))
          ], 34)
        ]),
        _: 1
      }, 8, ["container", "class", "name"]);
    };
  }
});
const picker = "_picker_108fg_1";
const pickerActionSeparator = "_pickerActionSeparator_108fg_10";
const pickerHeader = "_pickerHeader_108fg_14";
const pickerForm = "_pickerForm_108fg_23";
const pickerActionSubmit_disabled = "_pickerActionSubmit_disabled_108fg_30";
const pickerSelectAll = "_pickerSelectAll_108fg_35";
const style0 = {
  picker,
  pickerActionSeparator,
  pickerHeader,
  pickerForm,
  pickerActionSubmit_disabled,
  pickerSelectAll,
  "conflict-picker__all": "_conflict-picker__all_108fg_50"
};
const cssModules = {
  "$style": style0
};
const ConflictPicker = /* @__PURE__ */ _export_sfc(_sfc_main, [["__cssModules", cssModules]]);
export {
  ConflictPicker as default
};
//# sourceMappingURL=ConflictPicker.mjs.map
